module.exports = __webpack_public_path__ + "img/aboki.68919e98.png";